import React from "react";
import { Switch } from "@/components/ui/switch";
import { CheckinSettingsResponse } from "@/types/booking-checkin-settings";

interface PaymentTabProps {
  settings: CheckinSettingsResponse | null;
  setSettings: React.Dispatch<
    React.SetStateAction<CheckinSettingsResponse | null>
  >;
}

type PaymentSettingKey = "enabledPaymentForAccomodation" | "enabledPayLater";

export const PaymentTab: React.FC<PaymentTabProps> = ({
  settings,
  setSettings,
}) => {
  const toggleSetting = (key: PaymentSettingKey) => {
    setSettings((previousSettings) =>
      previousSettings
        ? {
            ...previousSettings,
            [key]: !previousSettings[key],
          }
        : previousSettings,
    );
  };

  if (!settings) {
    return null;
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-2">
        <Switch
          checked={settings.enabledPaymentForAccomodation}
          onCheckedChange={() => toggleSetting("enabledPaymentForAccomodation")}
        />
        <span className="text-lg font-normal">Payment for accommodation</span>
      </div>

      {settings.enabledPaymentForAccomodation && (
        <div className="pl-12 flex items-center gap-2">
          <Switch
            checked={settings.enabledPayLater}
            onCheckedChange={() => toggleSetting("enabledPayLater")}
          />
          <span className="text-lg font-normal">Pay Later</span>
        </div>
      )}
    </div>
  );
};
